import { createStyles } from '@mantine/core';

export default createStyles(() => ({
  card: {
    overflow: 'visible',
    width: '490px',
  },
}));
